module.exports = __webpack_public_path__ + "assets/img/znjsc.d35d3661.png";